import {useEffect, useRef, forwardRef} from 'react';
import { Link } from 'react-router-dom';
import AgriLogistics from './AgriLogistics';
import ColdChain from './ColdChain';
import Distribution from './Distribution';
import FleetTransportation from './FleetTransportation';
import OverlandExpress from './OverlandExpress';
import Warehouse from './Warehouse';


const Logistics = () => {
useEffect(()=>{
    let current_page = window.location.href.split('/').at(-1)
    setTimeout(()=>{
        document.getElementById(`${current_page}`).scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, 50)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+200;

        (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
    }, false);

    return(
        <div>
            <div id='express' className="logistics-image ">
                {/* <img src='internationalbanner.jpg' alt='' className='w-[100%]'/> */}
            </div>
            <div className="flex flex-col justify-center  gap-8 max-w-[50rem] mx-auto p-[3rem]">
                <p>Comming soon ...</p>
                <p>For further details, please contact us at 111-123-456.</p>

                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="flex">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/logistics/overland-express" className="font-bold">Overland Express</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/logistics/fleettransport" className="font-bold">Fleet & Transportation</Link></li>
                            </div>
                        </div>
                       

                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/logistics/warehousing" className="font-bold">Warehousing</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/logistics/distribution" className="font-bold">Distribution</Link></li>
                            </div>
                            
                        </div>

                        <div className="flex-1 flex flex-col">
                           
                            <div className="flex items-center">
                                <li><Link to="/logistics/coldchain" className="font-bold">Cold Chain</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/logistics/agrilogistics" className="font-bold">Agri Logistics</Link></li>
                            </div>
                            
                        </div>
                    </div>

                        
                </div>
            </div>

            <div id="overland-express">
                <OverlandExpress/>
            </div><div id="fleettransport">
                <FleetTransportation/>
            </div>
            <div id="warehousing">
                <Warehouse/>
            </div>
            <div id="distribution">
                <Distribution/>
            </div>
            <div id="coldchain">
                <ColdChain/>
            </div> 
            <div id="agrilogistics">
                <AgriLogistics/>
            </div> 
        </div> 
    );
};
export default Logistics;